<template>
    <v-card flat>
        <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row class="no-gutters pb-5">
                <v-col cols="12" sm="6" md="6" lg="7" :md="$canRoute('demo-acc-reg-tab') !== 1 ? 10 : 6" :lg="$canRoute('demo-acc-reg-tab') !== 1 ? 10 : 7">
                    <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here..." single-line solo
                        hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2" lg="2">
                    <ul>
                        <li>
                            <span>Total Deposit:</span>
                            <span>{{ formattedAllNumber(totalDeposit) }}</span>
                        </li>
                    </ul>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="3" v-if="$canRoute('demo-acc-reg-tab') === 1">
                    <ul>
                        <li>
                            <v-dialog transition="scale-transition" origin="center center" max-width="460"
                                v-model="dialogDeposit" content-class="deposit-withdraw-popup marketingPopup">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn tile elevation="0" class="text-capitalize" color="#039de9" v-bind="attrs"
                                        v-on="on">
                                        <v-icon> mdi mdi-plus </v-icon>
                                        New Demo Account
                                    </v-btn>
                                </template>
                                <!-- Dialog content goes here -->
                                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                                    ">
                                    <v-card-title class="pb-3 text-left justify-start pl-3">
                                        Add New Demo Account
                                    </v-card-title>
                                    <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                                        Create A New Demo Account For This User
                                    </v-card-subtitle>
                                    <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                                        ">
                                        <v-row>
                                            <v-col cols="12">
                                                <fieldset>
                                                    <legend>Account Type</legend>
                                                    <v-select v-model="trading_account_type_id" solo
                                                        :items="accountTypeOptions" item-text="displayText"
                                                        item-value="id" append-icon="mdi-chevron-down"
                                                        label="Click to select" class="custom-select"
                                                        hide-details></v-select>
                                                </fieldset>
                                            </v-col>
                                            <v-col cols="12">
                                                <fieldset>
                                                    <legend>Deposit</legend>
                                                    <v-text-field v-model="deposit" label="Type value" single-line solo
                                                        hide-details class="custom-select"></v-text-field>
                                                </fieldset>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <v-card-actions>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-btn tile @click="createDemoAccount" elevation="0"
                                                    class="text-capitalize btn-account mr-3 px-sm-8"
                                                    color="greenMain">Create</v-btn>
                                                <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
                                                    class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </li>
                    </ul>
                </v-col>
            </v-row>
        </v-card>
        <v-row>
            <v-col cols="12" sm="12">
                <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                    <v-sheet class="transactionTable depositTableForTransaction"
                        :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                        <v-data-table :headers="headers" :search="search" :items="userDemoAccounts" :items-per-page="5">
                            <template v-slot:item.created_at="{ item }">
                                {{ formatMySQLDate(item?.created_at) }}
                            </template>
                            <template v-slot:item.email="{ item }">
                                <v-tooltip top color="#000">
                                    <template v-slot:activator="{ on }">
                                        <v-btn plain title x-small v-on="on" @click="copyText(item)"
                                            style="text-transform: none">
                                            {{ obfuscateAnyEmail(item?.email) }}
                                            <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                                                {{
                                                    copiedStates[item.id]
                                                        ? "mdi mdi-check"
                                                        : "mdi-content-copy"
                                                }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.email }}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.accounts="{ item }">
                                {{ item?.fname }} {{ item?.lname }} {{ "(" + item.client_account_id + ")" }}
                            </template>
                            <template v-slot:item.leverage="{ item }">
                                {{ 1 + ":" + item.leverage }}
                            </template>
                            <template v-slot:item.password="{ item }">
                                {{
                                    item.password && item.password.length > 10
                                        ? item.password.substring(0, 10) + "..."
                                        : item.password || "N/A"
                                }}
                            </template>
                            <template v-slot:item.investor_password="{ item }">
                                {{
                                    item.investor_password && item.investor_password.length > 10
                                        ? item.investor_password.substring(0, 10) + "..."
                                        : item.investor_password || "N/A"
                                }}
                            </template>
                            <template v-slot:item.deposit="{ item }">
                                {{ item.deposit || "0.00" }}
                            </template>
                        </v-data-table>
                    </v-sheet>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS, COMMISSIONSETTINGS__ACTIONS } from "@/store/action-types";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { formatNumber } from "@/_helpers/formatNumber";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
    data() {
        return {
            search: "",
            client_account_id: "",
            trading_account_type_id: "",
            isCopied: false,
            copiedStates: {},
            dialogDeposit: false,
            headers: [
                { text: "Acc No", value: "trading_account_no" },
                { text: "Name", value: "clientname" },
                { text: "Email", value: "email" },
                { text: "Registered At", align: "start", value: "created_at" },
                { text: "Password", value: "password" },
                { text: "Investor Pass.", value: "investor_password" },
                { text: "Leverage", value: "leverage" },
                { text: "Deposit", value: "deposit" },
            ],
        };
    },
    computed: {
        ...mapState("reguserdetails", ["userDemoAccounts"]),
        ...mapState("commissionsettings", [
            "accountTypes"
        ]),
        ...mapState("admins", ["loggedAdmin"]),

        totalDeposit() {
            const total = this.userDemoAccounts.reduce((total, account) => {
                return total + (account.deposit !== null && account.deposit !== undefined ? account.deposit : 0);
            }, 0);
            return total.toFixed(2);
        },
        accountTypeOptions() {
            return this.accountTypes?.map((item) => ({
                id: item.id,
                displayText: item.account_type_display,
            }));
        },
    },
    methods: {
            //formatMySQLDate is needed for timeformat
    formatMySQLDate,
        ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.USERDEMOACCOUNTS, REGISTERUSERDETAILS__ACTIONS.CREATEDEMOACCOUNT]),

        ...mapActions("commissionsettings", [
            COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS
        ]),

        createDemoAccount() {
            const parameter = {
                client_account_id: this.client_account_id,
                trading_account_type_id: this.trading_account_type_id,
                deposit: this.deposit
            }
            this[REGISTERUSERDETAILS__ACTIONS.CREATEDEMOACCOUNT](parameter)
            this.dialogDeposit = false;
            this.trading_account_type_id = null;
            this.deposit = null
        },

        copyText(item) {
            navigator.clipboard.writeText(item.email);
            this.$set(this.copiedStates, item.id, true);
            setTimeout(() => {
                this.$set(this.copiedStates, item.id, false);
            }, 1000);
        },
        obfuscateAnyEmail(email) {
            return obfuscateEmail(email)
        },
        formattedAllNumber(num) {
            return formatNumber(num || 0);
        },
    },
    async mounted() {
        this.client_account_id = this.$route.params.id
        this[REGISTERUSERDETAILS__ACTIONS.USERDEMOACCOUNTS](this.$route.params.id);
        this[COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS]();
    },
};
</script>
